// Static package metadata (prices also read on-chain via getPackagePrices()).
export const PACKAGES = [
  { id: 1, price: 10, label: "Node Starter" },
  { id: 2, price: 50, label: "Node Bronze" },
  { id: 3, price: 100, label: "Node Silver" },
  { id: 4, price: 250, label: "Node Gold" },
  { id: 5, price: 500, label: "Node Platinum" },
  { id: 6, price: 1000, label: "Node Diamond" },
  { id: 7, price: 2000, label: "Node Elite" },
  { id: 8, price: 5000, label: "Node Master" },
  { id: 9, price: 10000, label: "Node Sovereign" },
];
